module.exports = __webpack_public_path__ + "img/安全产品示例图_2.536c6725.png";